import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import { wsGetAll } from 'services/WService';

import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function ModalRange(props) {
  const range = props.model;
  const [dataChanging, setDataChanging] = useState(range);
  const [zones, setZones] = useState([]);
  const [min, setMin] = useState(0);

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    if (range.open) listZones();
  }, [range.open]);

  return (
    <Modal
      title="Rango"
      model={range}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="com/range"
      state
    >
      <TextField
        label="Periodo"
        fullWidth
        type="month"
        name="period_date"
        margin="normal"
        defaultValue={moment().format('YYYY-MM') || ''}
        InputLabelProps={{ shrink: true }}
        required
        disabled={!!range?.period_date}
      />
      <TextField
        label="Rango min"
        fullWidth
        type="number"
        name="min_range"
        margin="normal"
        defaultValue={range?.min_range || ''}
        onChange={(e) => setMin(e.target.value)}
        inputProps={{ min: 0, step: 0.01 }}
        required
      />
      <TextField
        label="Rango máx"
        fullWidth
        type="number"
        name="max_range"
        margin="normal"
        defaultValue={range?.max_range || ''}
        inputProps={{ min: min, step: 0.01 }}
        required
      />
      <TextField
        label="Monto bonificación"
        fullWidth
        type="number"
        name="bonification_amount"
        margin="normal"
        defaultValue={range?.bonification_amount || ''}
        required
      />
      <TextField
        label="Monto bonificación 2"
        fullWidth
        type="number"
        name="bonification_amount_2"
        margin="normal"
        defaultValue={range?.bonification_amount_2 || ''}
        required
      />
      <FormControl fullWidth margin="normal">
        <InputLabel>Tipo comisión</InputLabel>
        <Select defaultValue={range.type_comision || ''} inputProps={{ name: 'type_comision' }}>
          <MenuItem value="R">Jefe Reparto</MenuItem>
          <MenuItem value="M">Encargado Mercadería</MenuItem>
          <MenuItem value="V">Vendedor</MenuItem>
          <MenuItem value="S">Supervisor</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal">
        <InputLabel>Tipo efectvidad</InputLabel>
        <Select defaultValue={range.type_efectivity || ''} inputProps={{ name: 'type_efectivity' }}>
          <MenuItem value="P">Pedidos</MenuItem>
          <MenuItem value="S">Soles</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal">
        <InputLabel>Zona</InputLabel>
        <Select defaultValue={range.base_zone_id || ''} inputProps={{ name: 'base_zone_id' }}>
          {zones.map((item, i) => {
            return (
              <MenuItem key={i} value={item.id}>
                {item.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Modal>
  );
}
